import css from './AI.module.scss';
export default function SlotsList({ slots, mutate, setStack, setStack2, makeDesign }) {
  return <div className={css.slotContainer}>
    {
      slots.length === 0 && <div className={css.noItems}>Nothing on stack</div>
    }
    {
      slots.length > 0 && slots.map(
        (slot, index) =>
          <div key={mutate ? slot.time : slot.level} className={mutate ? css.slot : css.slotInMemory}>

            <div className={css.slotName}>
              {
                mutate && <div className={css.close} onClick={() => { close(index) }}>X</div>
              }
              <div className={css.slotLevel}>{slot.level}</div>
              {slot.level}. {slot.name}
            </div>
            <div className={css.slotResolution}>
              {slot.resolution}
            </div>
            <div>
              {
                slot.keys.map
                  (
                    key =>
                      <div key={key.key}>
                        <h3 className={css.slotKey}>{key.key}: </h3>
                        <div className={css.labelField}>Type</div>
                        <div className={css.valueField}>{key.type}</div>
                        <div className={css.labelField}>Variations</div>
                        <div className={css.valueField}>
                          {
                            key.variations.map((item, index) => {
                              if (index === key.variations.length - 1) {
                                return item
                              }
                              return `${item}, `
                            })
                          }
                        </div>
                      </div>
                  )
              }
            </div>

            {
              slot.find && <>
                <div className={css.listOfWordsHeading}>
                  Match values
                </div>
                <div className={css.listOfWords}>
                  <pre className={css.listOfWordsItem}>
                    {JSON.stringify(slot.find, null, 2)}
                  </pre>
                </div>
              </>
            }

          </div>
      )
    }
  </div>

  function close(index) {
    slots.splice(index, 1);
    const newArray = [...slots];
    setStack(newArray);
    setStack2(newArray.slice().reverse());

    //makeDesign(false);
  }
}